import React, {forwardRef} from 'react';
import Page from '../../components/page';
import {Col } from 'react-bootstrap'

const Contact = forwardRef((props, ref) => {
    return (<Page header="Contact" className="Contact" ref={ref}>
    <Col>
    <p className="text-center" style={{fontSize: '2rem'}}>
    <a href="https://www.facebook.com/ElleFleurbloemenendecoraties/" className="text-dark" ><i className="bi-facebook"  /></a> <a href="https://www.instagram.com/elle_fleur_bloemendecoraties/" className="text-dark" ><i className="bi-instagram" /></a><br />

    </p>
    <p className="text-center">
    Uddelerveen 68c<br />
    3888 MN Uddel
        </p>
    </Col>

    </Page>);
});

export default Contact;